/**
 * Download plugin: emits `download` events for obvious file downloads.
 */
import type { PluginContext } from "../lib/types";

import { registerPlugin } from "./register";

const extensionPattern =
  /\.(pdf|zip|csv|xls|xlsx|doc|docx|ppt|pptx|txt|rtf|png|jpg|jpeg|webp|mp4|mov|mp3|wav)(?:$|\?)/i;

registerPlugin("download", (ctx: PluginContext) => {
  const onClick = (event: MouseEvent) => {
    if (!ctx.canTrack("analytics")) return;
    if (!ctx.canTrackCategory("behavioral_events")) return;
    const target = event.target as HTMLElement | null;
    const anchor = target?.closest("a") as HTMLAnchorElement | null;
    if (!anchor?.href) return;
    if (
      !anchor.hasAttribute("download") &&
      !extensionPattern.test(anchor.href)
    ) {
      return;
    }

    try {
      const url = new URL(anchor.href, window.location.href);
      ctx.track("download", {
        href_domain: url.hostname,
        href_path: url.pathname,
        ext: url.pathname.split(".").pop()?.toLowerCase(),
      });
    } catch {
      // ignore
    }
  };

  return {
    onInit() {
      document.addEventListener("click", onClick, { capture: true });
    },
    onUnload() {
      document.removeEventListener("click", onClick, true);
    },
  };
});
